const unprotectedPaths = ['/register'];

export const isUnprotectedPath = (path) => unprotectedPaths.includes(path);
